export default __webpack_public_path__ + "static/26-03e200ae8ef9fa7091656d333ced9f91.jpg";